var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  height: "100%",
  viewBox: "0 0 9 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.343 14.5a1 1 0 0 1-.71-1.71l5.3-5.29-5.3-5.29A1.004 1.004 0 0 1 2.053.79l6.7 6.71-6.7 6.71a1 1 0 0 1-.71.29"
})));
export default SvgChevronRight;